import { render, staticRenderFns } from "./other-deposit.vue?vue&type=template&id=41b2216d&scoped=true"
import script from "./other-deposit.vue?vue&type=script&lang=js"
export * from "./other-deposit.vue?vue&type=script&lang=js"
import style0 from "./other-deposit.vue?vue&type=style&index=0&id=41b2216d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b2216d",
  null
  
)

export default component.exports